// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nb-0";
export var assigneeDetails = "_nb-1";
export var assigneeInfo = "_nb-2";
export var dropdownContainer = "_nb-4";
export var dropdownImage = "_nb-5";
export var editAssigneeInfo = "_nb-3";
export var editAssigneeModalContainer = "_nb-6";
export var hidden = "_nb-8";
export var input = "_nb-7";